import React, { useId } from 'react';

type GradientStop = { offset: string; opacity: number };

export const useChartGradient = (color: string, stops: GradientStop[]) => {
  const id = useId().replace(/:/g, '');
  const defs = (
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
        {stops.map((stop) => (
          <stop key={stop.offset} offset={stop.offset} stopColor={color} stopOpacity={stop.opacity} />
        ))}
      </linearGradient>
    </defs>
  );
  return { id, fill: `url(#${id})`, defs };
};
